import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-red-dot',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (visible()) {
      <span class="absolute right-0 top-0 block h-[10px] w-[10px] rounded-full bg-red-500" [ngClass]="styleClass()"></span>
    }
  `,
})
export class RedDotComponent {
  visible = input(false);
  styleClass = input('');
}
